import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { VisualiserMessages } from '../../../shared/models/component-messages/visualiser-messages';
import { AvisService } from '../../services/avis-service';

@Component({
	selector: 'app-popup-enregistrer',
	templateUrl: './popup-enregistrer.component.html'
})
export class PopupEnregistrerComponent implements OnInit {
	public visualiserMessages = new VisualiserMessages();
	public referenceAvis: string;

	constructor(public activeModal: NgbActiveModal, private avisService: AvisService) {}

	public ngOnInit() {}

	public shouldUpdateSynthesis(value: boolean): void {
		this.avisService.shouldUpdateSynthesis = value;
		this.activeModal.dismiss('close');
	}
}
